import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { CartProvider } from './context/CartContext';
// IMPORT THIS
import { GoogleOAuthProvider } from '@react-oauth/google';
import { HelmetProvider } from 'react-helmet-async';
import axios from 'axios';

// Use an explicit API URL only when configured.
// Otherwise keep requests relative so CRA proxy works in development
// and same-origin requests work in production.
axios.defaults.baseURL = process.env.REACT_APP_API_URL || '';

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

if (!googleClientId) {
  throw new Error('Missing REACT_APP_GOOGLE_CLIENT_ID. Set it in frontend/.env and restart the React dev server.');
}

if (process.env.NODE_ENV === 'development') {
  console.info('[Google OAuth config]', {
    origin: window.location.origin,
    clientId: googleClientId,
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HelmetProvider>
    <GoogleOAuthProvider clientId={googleClientId}>
      <CartProvider>
        <App />
      </CartProvider>
    </GoogleOAuthProvider>
  </HelmetProvider>
);
